import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

// assets
import Loader from '../../../../assets/img/loader.gif'

// components
import IndoorMap from '../../../../components/home/IndoorMap/IndoorMap'
import ActionButton from '../../../../components/ui/ActionButton/ActionButton'
import Icon from '../../../../components/ui/Icon/Icon'
import Header from '../../../../components/ui/Header/container/Header'

export const PageWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const HeaderWrapper = styled.div`
  flex: 0 0 auto;
`

export const StyledHeader = styled(Header)`
  position: relative;
`

export const ContentWrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  height: 100%;
`

export const IndoorMapWrapper = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const StyledIndoorMap = styled(IndoorMap)``

export const MapDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  height: 100%;
  width: 375px;
  background: #ffffff;
  box-shadow: -1px 0 0 0 rgba(85, 69, 13, 0.2);
  z-index: 3;

  ${media.lessThan('small')`
    display: none;

    ${props =>
      props.displayMobile &&
      css`
        display: flex;
        position: absolute;
        width: 100%;
        z-index: 6;
      `};
  `}
`

export const SelectMallButton = styled.button`
  display: flex;
  flex: 1 1 375px;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  background: #ffffff;
  height: 3rem;
  border: 1px solid var(--color-bg);
  border-radius: 4px;
  margin-right: 1.25rem;
  padding: 0 1rem;

  ${media.lessThan('medium')`
    width: 100%;
  `}
`

export const ImageHeader = styled.div.attrs(props => ({
  style: {
    background: `var(--color-primary)  url('${props.bgImage}') center / cover`,
  },
}))`
  flex: 0 0 auto;
  height: 217px;
  width: 100%;
`

export const CloseButton = styled.button`
  display: none;
  position: absolute;
  color: var(--color-fg);
  border: 0;
  background-color: transparent;
  top: 15px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 100%;
  outline: none;

  > svg {
    vertical-align: baseline;
  }

  ${media.lessThan('small')`
    display: block;
  `}
`

export const Title = styled.h2`
  font-family: var(--font-family-ayala-display-sans);
  font-size: 1.375rem;
  font-weight: var(--font-weight-boldest);
  line-height: 1.9375rem;
  margin: 0;
`

export const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0;
  margin-bottom: 0;
`

export const StyledActionButton = styled(ActionButton)`
  font-size: 0.75rem;
  font-weight: var(--font-weight-boldest);
  margin-top: 3.125rem;
  margin-bottom: 1.6875rem;
  height: 36px;
  width: 100%;
`

export const MapDetailContentHeader = styled.div`
  flex: 0 0 auto;
  position: relative;
  top: -1.5rem;
  padding: 0 1.6875rem;
`

export const MapDetailContent = styled.div`
  flex: 1 1 auto;
  position: relative;
  overflow: auto;
  padding: 0 1.6875rem 1.6875rem;
`

export const MerchantLogo = styled.img`
  float: left;
  max-height: 80px;
  max-width: 80px;
  margin-right: 1.25rem;
  margin-bottom: 1.25rem;
`

export const Body = styled.div`
  line-height: 1.75rem;
  > p {
    &:first-child {
      margin-top: 0;
    }
  }

  > figure {
    margin: 0;

    > img {
      max-width: 100%;
    }
  }

  margin-bottom: 4rem;
`

export const StoreLinksContainer = styled.div`
  padding-top: 3rem;
`

export const StoreLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  border-top: 1px solid var(--color-fg-lighter);
  padding: 0.8rem 0;
  justify-content: flex-start;

  > p {
    line-height: 1.75rem;
    margin: 0;
    padding: 0 1rem;
    flex: 1;
  }
`

export const DescriptionItem = styled.p`
  flex: 1 1 auto;
  overflow-wrap: break-word;
  word-wrap: break-word;

  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;

  /* Adds a hyphen where the word breaks, if supported (No Blink) */
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
`

export const StoreLinkDescription = styled.p`
  flex: 1 1 auto;
  font-size: 0.9375rem;
  font-weight: var(--font-weight);
  display: inline-flex;
  flex-direction: column;
  min-width: 0;

  > p {
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    margin-bottom: 0.5rem;
    word-wrap: break-word;

    &:last-child {
      margin: 0;
    }
  }
`

export const IconContainer = styled.div`
  display: flex;
  color: var(--color-primary);
  font-size: 1rem;
  margin-top: 0.3rem;
`

export const StyledLink = styled.a`
  flex: 0 0 auto;
  font-size: 0.75rem;
  font-weight: var(--font-weight-boldest);
  text-decoration: none;
  cursor: pointer;
  margin-top: 0.3rem;
  text-transform: uppercase;
`

export const LoadingContainer = styled.div`
  min-height: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
`

export const LoadingIcon = styled.img.attrs({ src: Loader })`
  height: 5rem;
  width: 5rem;
`

export const DetailCard = styled.div`
  display: none;
  position: absolute;
  bottom: 133px;
  left: 0;
  right: 0;
  margin: 0 1.1875rem 0.625rem;
  height: 80px;
  background-color: #ffffff;
  box-shadow: var(--box-shadow);
  z-index: 1;
  border-radius: 5px;
  overflow: hidden;

  ${media.lessThan('small')`
    display: flex;
  `}
`

export const CardImage = styled.div.attrs(props => ({
  style: {
    background: `url('${props.image}') center / cover`,
  },
}))`
  flex: 0 0 80px;
  height: 80px;
  width: 80px;
  background-color: var(--color-primary);
`

export const CardDescriptionWrapper = styled.div`
  flex: 1 1 auto;
  padding: 1rem;
  min-width: 0;
`

export const DescriptionHeaderWrapper = styled.div`
  display: flex;
  margin-bottom: 0.25rem;
`

export const HeaderTitle = styled.h2`
  flex: 1 1 auto;
  font-size: 0.625rem;
  margin: 0;
  margin-right: 0.5rem;
  text-transform: uppercase;
  max-width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const ReadMore = styled.span`
  cursor: pointer;
  flex: 0 0 auto;
  font-size: 0.625rem;
  color: var(--color-primary);
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
`

export const CardDescription = styled.p`
  font-size: 0.625rem;
  margin: 0;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const StyledXIcon = styled(Icon).attrs({ name: 'x' })``
